module.exports = __webpack_public_path__ + "img/pricing-tree-2.d72ecb7a.png";